export default __webpack_public_path__ + "static/media/Logo_Dark_New.40be50bf.png";